import { api } from "@/lib/api";
import { useSession } from "@/lib/auth-client";
import { useQuery } from "@tanstack/react-query";

// Resolves the display name of the currently-active org, mirroring the logic in
// AppSidebar's OrgSwitcher — including the super-admin "viewing a foreign org"
// case where the active org isn't in the member's own list. Uses the same query
// keys as OrgSwitcher, so it shares the react-query cache and adds no fetches.
export function useActiveOrgName(): string | null {
  const { data: session } = useSession();

  const orgsQuery = useQuery({ queryKey: ["orgs"], queryFn: api.orgs.list });
  const orgs = orgsQuery.data ?? [];

  const activeOrgId = session?.session.activeOrganizationId ?? null;
  const activeOrg = orgs.find((o) => o.id === activeOrgId);

  const viewingForeignOrg =
    !!activeOrgId && !activeOrg && !orgsQuery.isLoading && !orgsQuery.isError;

  const foreignOrgQuery = useQuery({
    queryKey: ["admin", "org", activeOrgId],
    queryFn: () => api.admin.org(activeOrgId!),
    enabled: viewingForeignOrg,
    staleTime: 5 * 60 * 1000,
  });

  if (activeOrg) return activeOrg.name;
  if (viewingForeignOrg) return foreignOrgQuery.data?.data.name ?? null;
  return null;
}
